module.exports = __webpack_public_path__ + "img/logo.4a6301fb.svg";